module.exports = __webpack_public_path__ + "static/media/sign-up-approve.963e80ee.gif";